unique.utilities = {
    registerEvents: function ( strEvents, strNamespaceLocal ) {
        var objEvents = {},
            strNamespace = [
                'unique',
                strNamespaceLocal
            ].join( '.' );
        jQuery.each( strEvents.split( ' ' ), function ( intIndex, strEventName ) {
            objEvents[ strEventName ] = [
                strEventName,
                strNamespace
            ].join( '.' );
        } );
        return objEvents;
    },
    loader: {
        show: function ( domNode ) {
            var jLoader = jQuery( domNode ).find( '.js-e-loading-overlay' ).addClass( 'is-loading' );
            jLoader.closest( '.js-unique-modal-form-with-loader ' ).addClass( 'is-loading' );
            jLoader.closest( '.modal' ).modal( 'handleUpdate' );
        },
        hide: function ( domNode ) {
            var jLoader = jQuery( domNode ).find( '.js-e-loading-overlay' ).removeClass( 'is-loading' );
            jLoader.closest( '.js-unique-modal-form-with-loader ' ).removeClass( 'is-loading' );
            jLoader.closest( '.modal' ).modal( 'handleUpdate' );
        }
    },
    modal: {
        show: function ( domNode ) {
            jQuery( domNode ).closest( '.modal' ).modal( 'show' );
        },
        hide: function ( domNode ) {
            jQuery( domNode ).closest( '.modal' ).modal( 'hide' );
        }
    },
    callback: {
        /* jshint ignore:start */
        done: function ( jsonOffer, strTextStatus, jqXhr, domNode ) {
            if ( domNode !== undefined ) {
                var _getDoneMessage = function ( domNode ) {
                        var strReturnValue = null,
                            strMessage = jQuery( domNode ).data( 'done-msg' );
                        if ( strMessage !== undefined ) {
                            strReturnValue = strMessage;
                        }
                        else {
                            strReturnValue = strTextStatus;
                        }
                        return strReturnValue;
                    },
                    _getDoneUrl = function ( domNode, jsonOffer ) {
                        console.log( '_getDoneUrl data', jQuery( domNode ).data() );
                        var strReturnValue = null,
                            strUrl = jQuery( domNode ).data( 'done-url' );
                        if ( strUrl !== undefined ) {
                            strReturnValue = strUrl;
                        }
                        console.log( '_getDoneUrl url', strUrl );
                        return strReturnValue;
                    };
                var strMessage = _getDoneMessage( domNode ),
                    strUrl = _getDoneUrl( domNode, jsonOffer );
                console.info( 'done callback', strMessage, strUrl );
                if ( strMessage !== null ) {
                    if ( strUrl !== null ) {
                        unique.utilities.message.showOnRedirect( strMessage, e4.settings.cmdMsg.type.success, strUrl );
                        console.info( strUrl, strMessage, e4.settings.cmdMsg.type.success );
                    }
                    else {
                        var jModal = jQuery( domNode ).closest( '.modal' );
                        if ( jModal.length === 1 ) {
                            jModal.one( 'hidden.bs.modal', function () {
                                unique.utilities.message.showOnPage( strMessage, e4.settings.cmdMsg.type.success );
                            } );
                            unique.utilities.modal.hide( domNode );
                            unique.utilities.loader.hide( domNode );
                        }
                        else {
                            unique.utilities.message.showOnPage( strMessage, e4.settings.cmdMsg.type.success );
                        }
                    }
                }
            }
        },
        fail: function ( jqXhr, strTextStatus, objErrorThrown, domNode ) {
            if ( domNode !== undefined ) {
                var _getFailMessage = function ( domNode ) {
                        var strReturnValue = null,
                            strMessage = jQuery( domNode ).data( 'fail-msg' );
                        if ( strMessage !== undefined ) {
                            strReturnValue = strMessage;
                        }
                        else {
                            strReturnValue = strTextStatus;
                        }
                        return strReturnValue;
                    },
                    _getFailUrl = function ( domNode ) {
                        var strReturnValue = null,
                            strUrl = jQuery( domNode ).data( 'fail-url' );
                        if ( strUrl !== undefined ) {
                            strReturnValue = strUrl;
                        }
                        return strReturnValue;
                    };
                var strMessage = _getFailMessage( domNode ),
                    strUrl = _getFailUrl( domNode );
                console.log( 'fail callback', strMessage, strUrl, objErrorThrown );
                if ( strMessage !== null ) {
                    if ( strUrl !== null ) {
                        // unique.utilities.message.showOnRedirect( strMessage, e4.settings.cmdMsg.type.fail, strUrl );
                        console.error( 'REDIRECT', strUrl, strMessage, e4.settings.cmdMsg.type.fail );
                    }
                    else {
                        var jModal = jQuery( domNode ).closest( '.modal' );
                        if ( jModal.length === 1 ) {
                            unique.utilities.message.showInModal( strMessage, e4.settings.cmdMsg.type.fail, jModal.get( 0 ) );
                            unique.utilities.loader.hide( domNode );
                        }
                        else {
                            unique.utilities.message.showOnPage( strMessage, e4.settings.cmdMsg.type.fail );
                        }
                    }
                }
            }
        },
        /* jshint ignore:end */
    },
    message: {
        loadDependencies: function ( fnCallback, arrCallbackArgs ) {
            e4.require.js( e4.settings.require.handlebars, function () {
                e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-cmd-message' );
                e4.handlebars.registerHelpers( 'compare' );
                fnCallback.apply( null, arrCallbackArgs );
            } );
        },
        showOnPage: function ( strMessage, strMessageType ) {
            unique.utilities.message.loadDependencies( function () {
                jQuery( '.js-unique-cmd-msg' ).html( e4.handlebars.tmpl.cmdMessage( {
                    message: strMessage,
                    messageType: strMessageType
                } ) ).addClass( 'show' );
                setTimeout( function () {
                    unique.utilities.message.hideOnPage();
                }, e4.settings.ecom.cart.msgHideDelay );
            } );
        },
        hideOnPage: function () {
            jQuery( '.js-unique-cmd-msg' ).removeClass( 'show' );
        },
        showInModal: function ( strMessage, strMessageType, domModal ) {
            unique.utilities.message.loadDependencies( function () {
                var jModal = jQuery( domModal );
                jModal.find( '.modal-body' ).prepend( e4.handlebars.tmpl.cmdMessage( {
                    message: strMessage,
                    messageType: strMessageType
                } ) );
                jModal.modal( 'handleUpdate' );
            } );
        },
        showOnRedirect: function ( strMessage, strMessageType, strUrl ) {
            var _appendMessageToUrl = function ( strUrl, strMessage, strMessageType ) {
                var returnValue = strUrl;
                if ( returnValue !== null && strMessage !== null ) {
                    returnValue = unique.utilities.appendParameterToUrl( returnValue, e4.settings.cmdMsg.paramName, strMessage );
                    if ( e4.settings.cmdMsg.type[ strMessageType ] !== undefined ) {
                        returnValue = unique.utilities.appendParameterToUrl( returnValue, e4.settings.cmdMsg.typeParamName, e4.settings.cmdMsg.type[ strMessageType ] );
                    }
                }
                return returnValue;
            };
            location.href = _appendMessageToUrl( strUrl, strMessage, strMessageType );
        }
    },
    appendParameterToUrl: function ( strUrl, strParamName, strParamValue ) {
        var returnValue = null;
        if ( strUrl !== undefined && strUrl !== null ) {
            returnValue = e4.util.stringify( strUrl );
            if ( returnValue.indexOf( '?' ) === -1 ) {
                returnValue += '?';
            }
            else {
                returnValue += '&';
            }
            returnValue += jQuery.param( [
                {
                    name: strParamName,
                    value: strParamValue
                }
            ] );
        }
        return returnValue;
    },
    looksLikeUrl: function ( strValue ) {
        return strValue !== undefined && strValue !== null && ( e4.util.stringify( strValue ).indexOf( '/' ) === 0 || e4.util.stringify( strValue ).indexOf( 'http' ) === 0 );
    },
    getAllSubmitButtonsInForm: function ( domForm ) {
        return jQuery( domForm ).find( 'input[type="submit"],button' ).not( '[type="button"],[type="reset"]' );
    },
    enableAllSubmitButtonsInForm: function ( domForm ) {
        unique.utilities.getAllSubmitButtonsInForm( domForm ).prop( 'disabled', false );
    },
    disableAllSubmitButtonsInForm: function ( domForm ) {
        unique.utilities.getAllSubmitButtonsInForm( domForm ).prop( 'disabled', true );
    },
    serializeFormToObject: function ( domForm ) {
        // https://api.jquery.com/jQuery.param/
        var objReturnValue = {},
            arrFormFields = jQuery( domForm ).serializeArray();
        for ( var i = 0; i < arrFormFields.length; i++ ) {
            var strFormFieldName = arrFormFields[ i ][ 'name' ],
                strFormFieldValue = arrFormFields[ i ][ 'value' ];
            if ( strFormFieldValue === undefined || strFormFieldValue === null ) {
                strFormFieldValue = '';
            }
            objReturnValue[ strFormFieldName ] = strFormFieldValue;
        }
        return objReturnValue;
    },
    ajax: function ( objAjaxSettings, fnCallback ) {
        var jqXHR = jQuery.ajax( jQuery.extend( {
            url: null,
            method: 'GET',
            dataType: 'json',
            cache: false,
        }, objAjaxSettings ) );
        jqXHR.done( function ( data ) {
            if ( typeof fnCallback === 'function' ) {
                fnCallback( data );
            }
        } );
        jqXHR.fail( function () {
            console.trace( objAjaxSettings, arguments );
        } );
        return jqXHR;
    },
};
